import { createFileRoute } from "@tanstack/react-router";
import BrainWontShutOff from "@/pages/BrainWontShutOff";
export const Route = createFileRoute("/brain-wont-shut-off")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Brain Wont Shut Off | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Racing thoughts, insomnia, and depression go hand in hand. Learn how TMS and SAINT TMS may help calm an overactive brain in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Brain Wont Shut Off | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Racing thoughts, insomnia, and depression go hand in hand. Learn how TMS and SAINT TMS may help calm an overactive brain in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/brain-wont-shut-off",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/brain-wont-shut-off",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BrainWontShutOff />;
}
